import { render } from "./EmployeeDiscountComponent.vue?vue&type=template&id=189a64dc"
import script from "./EmployeeDiscountComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeDiscountComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__